import { controls, currencyToNumber, grouped } from "../../controls";

const rpad1 = {
  label: "Inspecting Officer Report",
  starting: true,
  url: "rp101m",
  pageLabel: "Inspecting Officer Report",
  pageType: "history",
  // filteraction: true,
  filter: [

    ...controls.displayText({ tab: "general", label: "Bank", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "Client", placeHolder: "Bank Code", name: "client_code", isRequired: true, fastpath: "clients", clearData: ["branch_code"] }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "client_display" }),


    ...controls.displayText({ tab: "general", label: "Branch", star: true }),
    ...controls.oc({
      tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", isRequired: true, fastpath: "branches",
      sendToServer: { sendData: [{ varname: "client.client_uid", value: "client_uid" }] }
    }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),


    ...controls.displayText({ tab: "general", label: "Inspecting Officer", star: true }),
    ...controls.oc({ tab: "general", length: 4, c: "User", placeHolder: "Inspecting Officer Code", name: "user_code", isRequired: true, fastpath: "users" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "user_display" }),

    // ...controls.magicDateLabel({ tab: "filter", label: "Audit Date", width: "col-sm-2", target: "as_on_date" }),
    // ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lqe" }),



  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Inspecting Officer Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
      header: [
        [{ source: 'fixed', value: 'Bank:' }, { field: 'client_display', type: "capital" }, { source: 'fixed', value: '. Branch:' }, { field: 'branch_display', type: "capital" }],
        [{ source: 'history', field: 'reportHeader' }]
      ]
    },
    textReportProps: {
      'Recon': {
        filename: `Auditor Report-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Bank",
        accessor: "client_display",
        rwidth: "*"
      },
      {
        Header: "Branch",
        accessor: "branch_display",
      },
      {
        Header: "Inspecting Officer",
        accessor: "auditor_display",
      },
      {
        Header: "Cash",
        accessor: "cash",
        type: "tick"
      },
      {
        Header: "Recon",
        accessor: "recon",
        type: "tick"
      },
      {
        Header: "Cheques & Bills",
        accessor: "cheques",
        type: "tick"
      },
      {
        Header: "Manual",
        accessor: "manual",
        type: "tick"
      },
      {
        Header: "General",
        accessor: "general",
        type: "tick"
      },
      {
        Header: "Loan",
        accessor: "loans",
        type: "tick"
      },
      {
        Header: "Deposit",
        accessor: "deposits",
        type: "tick"
      },
      {
        Header: "NPA",
        accessor: "npa",
        type: "tick"
      },

    ]
  }
};

export default rpad1;